module.exports = __webpack_public_path__ + "static/img/kong_icon.939e94e.png";


//////////////////
// WEBPACK FOOTER
// ./src/comm/images/document-conversion/zxyl/kong_icon.png
// module id = pQRU
// module chunks = 2